import React, { useState } from "react";
import HeaderSlider from "./HeaderSlider";
import SearchButton from "./HomeSearchBox/SearchButton";
import Title from "./HomeSearchBox/Title";
import { useHomeContext } from "@/context/homeContext";
import { useRouter } from "next/router";
import VillaTypeDropdown from "../SearchPublicClass/VillaTypeDropdown";
import RegionDropdown from "../SearchPublicClass/RegionDropdown";
import DateDropdown from "../SearchPublicClass/DateDropdown";
import GuestsDropdown from "../SearchPublicClass/GuestsDropdown";

const HomeSearchBox = ({ data, sliderCaption }) => {
  const router = useRouter();
  const { filterForm } = useHomeContext();

  const [showTips, setShowTips] = useState(false);
  const [showAreas, setShowAreas] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);
  const [showGuest, setShowGuest] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async (e) => {
    const module = await import("@/utils/handleSearchSubmit");
    module.handleSearchSubmit({
      e,
      filterForm,
      router,
      setIsLoading,
    });
  };
  
  return (
    <div
      className={`relative lg:mx-0 mx-3 lg:rounded-[0px] rounded-2xl lg:overflow-visible overflow-hidden lg:mb-0 mb-4 lg:static ${
        showTips || showAreas || showCalendar || showGuest
          ? "lg:z-10 z-50 lg:relative"
          : "z-10"
      }`}
    >
      <div className="flex flex-col items-center justify-center lg:pt-[68px] pt-2 lg:pb-0 pb-16 lg:-mb-[50px] lg:z-0 z-[8] lg:static relative lg:bg-transparent  md:mb-0">
        <div className="w-full max-w-[926px] px-2 z-10">
          <Title sliderCaption={sliderCaption} />
          <div className="relative flex-col hidden bg-white lg:flex rounded-xl shadow-searchShadow">
            <div className="flex flex-wrap items-center w-full py-4 pl-3 pr-3 lg:flex-nowrap lg:pl-9">
              <VillaTypeDropdown
                showTips={showTips}
                tips={data.tips}
                setShowTips={setShowTips}
              />
              <RegionDropdown
                showAreas={showAreas}
                setShowAreas={setShowAreas}
                destinations={data.destinations}
              />
              <DateDropdown
                setShowCalendar={setShowCalendar}
                showCalendar={showCalendar}
                setShowGuest={setShowGuest}
              />
              <GuestsDropdown
                showGuest={showGuest}
                setShowGuest={setShowGuest}
              />
              <SearchButton handleSubmit={handleClick} isLoading={isLoading} />
            </div>
          </div>
        </div>
      </div>
      <HeaderSlider sliderCaption={sliderCaption} />
    </div>
  );
};

export default HomeSearchBox;
